"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NON_PIXEL_NUMBER_PROPS = [
    'column-count',
    'font-weight',
    'flex-basis',
    'flex',
    'flex-grow',
    'flex-shrink',
    'opacity',
    'order',
    'z-index',
    'zoom'
];
function provideUnits(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === 'number' &&
        NON_PIXEL_NUMBER_PROPS.indexOf(name) === -1) {
        rulePairs[index + 1] = value + "px";
    }
}
exports.provideUnits = provideUnits;
//# sourceMappingURL=provideUnits.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/merge-styles/lib/transforms/provideUnits.js
// module id = ../node_modules/@uifabric/merge-styles/lib/transforms/provideUnits.js
// module chunks = 1